const TIME_ZONE = 'Europe/Amsterdam'

/**
 * Zet een datum om naar een `YYYY-MM-DD`-sleutel in Amsterdamse tijd.
 *
 * Niet via toISOString(): dat rekent naar UTC, waardoor een avond in de zomer
 * op de vorige dag uitkomt. De nachtklus gebruikt dezelfde sleutel, dus een
 * afwijking hier zou de agenda naar een ander document laten schrijven.
 *
 * SPIEGEL: functions/personas/tsToAmsterdamDateKey.js doet hetzelfde voor een
 * Firestore Timestamp aan de serverkant.
 *
 * @param {Date|null|undefined} date
 * @returns {string} De sleutel, of '' bij een ontbrekende of onleesbare datum
 */
const amsterdamDateKey = (date) => {
    if (!date) return ''

    const value = date instanceof Date ? date : new Date(date)
    if (Number.isNaN(value.getTime())) return ''

    const parts = new Intl.DateTimeFormat('en-CA', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        timeZone: TIME_ZONE,
    }).formatToParts(value)

    const year = parts.find((part) => part.type === 'year')?.value
    const month = parts.find((part) => part.type === 'month')?.value
    const day = parts.find((part) => part.type === 'day')?.value

    if (!year || !month || !day) return ''
    return `${year}-${month}-${day}`
}

export default amsterdamDateKey
